import { schemas, ZInfer } from '@showrunner/scrapi'

import defaultJSON from './default.json'
import gameTheoryJSON from './game-theory.json'
import gameJSON from './game.json'
import lwtJSON from './lwt.json'
import nabDemoJSON from './nab-demo.json'

export type RundownSchema = ZInfer<typeof schemas.RundownSchema>
export { templateSchema } from './templateSchema'

const GAME = gameJSON as RundownSchema
const LWT = lwtJSON as RundownSchema
const NAB_DEMO = nabDemoJSON as RundownSchema
const GAME_THEORY = gameTheoryJSON as RundownSchema
const DEFAULT = defaultJSON as RundownSchema

const PRESET_SCHEMA_NAMES = [
  'DEFAULT',
  'GAME',
  'GAME_THEORY',
  'LWT',
  'NAB_DEMO',
]
export type PresetSchemaName = (typeof PRESET_SCHEMA_NAMES)[number]

export const PRESET_SCHEMAS: Record<PresetSchemaName, RundownSchema> = {
  DEFAULT,
  GAME,
  LWT,
  NAB_DEMO,
  GAME_THEORY,
}
